import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  AbstractDialog,
  AbstractDialogData,
  AbstractDialogResultData,
} from '@next/core-lib/dialog';
import { LocaleService } from '@next/core-lib/i18n';

export interface GrainRegistrationReminderDialogData extends AbstractDialogData {
  year: number;
}

@Component({
  selector: 'app-grain-registration-reminder-dialog',
  templateUrl: './grain-registration-reminder-dialog.component.html',
  styleUrls: ['./grain-registration-reminder-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GrainRegistrationReminderDialogComponent extends AbstractDialog<never> {
  readonly data = inject<GrainRegistrationReminderDialogData>(MAT_DIALOG_DATA);
  private readonly locale = inject(LocaleService);
  protected readonly mdDialogRef = inject<MatDialogRef<GrainRegistrationReminderDialogComponent, AbstractDialogResultData<never>>>(MatDialogRef);

  bulletPoints: string[] = [];

  constructor() {
    super();
    this.loadBulletPoints();
  }

  private loadBulletPoints(): void {
    const bulletPoints = this.locale.translate('grainRegistrationReminder.bulletPoints');
    this.bulletPoints = bulletPoints.split(',').map((point) => point.trim());
  }

  dismiss(): void {
    this.mdDialogRef.close();
  }
}
